// اضافه کردن کتابخانه ها به صفحه
import * as React from "react";
import NavBar from "../../components/NavBar";
import {ArrowBack, ArrowForward, Brightness1, Delete, Edit, LocationOn} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {Backdrop, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, Pagination, PaginationItem, Tab, Tabs} from "@mui/material";
import Button from "@mui/material/Button";
import {Link} from "react-router-dom";
import {setActiveMenu} from "../../redux/dashboard/actions";
import {useDispatch, useSelector} from "react-redux";
import {setLoading} from "../../redux/loading/actions";
import {useSnackbar} from "notistack";
import HandleFetchData from "../../plugin/HandleFetchData";
import {ThemeContext} from "../../App";


export default function ListAddress() {
  // استفاده از متود های i18n برای چند زبان کردن پروژه و تغییر زبان پروژه
  const {t} = useTranslation()
  const {enqueueSnackbar} = useSnackbar();
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const {fetchData} = HandleFetchData()
  const theme = React.useContext(ThemeContext)

  const [listAddress, setListAddress] = React.useState([]);
  const [page, setPage] = React.useState(1);


  React.useEffect(() => {
    getListAddress()
  }, [])

  const getListAddress = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'GET', '/getAddress', '',
       "application/x-www-form-urlencoded",{
         "PageSize":"10",
         "PageIndex":"0"
       }, '',''
    )
    dispatch(setLoading(false))
    // console.log('fetch?', fetch)
    setListAddress(fetch?.Data)
    // setListAddressReceiver(fetchReceiver?.data)
  }

  // const deleteAddress = async () => {
  //   dispatch(setLoading(true))
  //   let fetch = await fetchData('', 'DELETE', '/address-books', {
  //        "address_book_id": idAddressForDel
  //      },
  //      'application/json', '', '',''
  //   )
  //   setLoading(false)
  //   setDialogDeleteAddress(false)
  //   setIdAddressForDel(null)
  // }


  const handleChangePagination = (event, value) => {
    // handlerGetFactor(value)
    setPage(value);
  };

  return (
     <>
       {selector?.loading?.isLoading &&
       <div className="backdrop-loading">
         <div className="backdrop-bg">
           <div className="loader" style={theme.darkMode ? {backgroundImage: "url('/splash2.gif')"} : {backgroundImage: "url('/splash1.gif')"}}/>
         </div>
       </div>
       }

       {/*کامپوننت نوبار*/}
       <div className="d-block d-lg-none">
         <NavBar blue back/>
       </div>

       <div className="listAddressPage desktopSection">
         <div className="container">
           <h4 className="titleSection">{t("dashboard.address.t15")}</h4>
           <div className="row">
             {
               listAddress?.map(item => {
                 return(
                    <div className="col-12 col-md-6 mb-3" key={item?.id}>
                      <div className="listAddress">
                        <div className="addressText">
                          <LocationOn/>
                          <span>
                     <b>{t("dashboard.address.t16")} : </b>
                            {item?.Address1}
                        </span>
                        </div>
                        <div className="receiverUse">
                          <Brightness1/>
                          <span>
                     <b>{t("dashboard.address.t17")} : </b>
                            {item?.FirstName + ' ' + item?.LastName}
                   </span>
                        </div>

                        {/*<div className="actionIcon">*/}
                        {/*  <button type="button">*/}
                        {/*    <Edit/>*/}
                        {/*  </button>*/}
                        {/*  <button type="button">*/}
                        {/*    <Delete/>*/}
                        {/*  </button>*/}
                        {/*</div>*/}
                      </div>
                    </div>
                 )
               })
             }

             {
               !listAddress?.length && <div className="notFindMessage">
                 <img src={require('./../../assets/img/vector/1.png')} alt="vector"/>
                 <p>{t("error.t2")}</p>
               </div>
             }

           </div>


           <div className="paginate">
             <Pagination
                count={10} page={page} onChange={handleChangePagination}
                renderItem={(item) => (
                   <PaginationItem
                      slots={{previous: ArrowBack, next: ArrowForward}}
                      {...item}
                   />
                )}
             />
           </div>
         </div>
       </div>
     </>
  )
}
